export enum UserRolesEnum {
    Foreman = 'Foreman',
    LabourOffice = 'LabourOffice',
    Payroll = 'Payroll',
    RestrictedForeman = 'RestrictedForeman'
}

export enum UserRolesConditionEnum {
    All = 'All',
    Any = 'Any'
}
